// extracted by mini-css-extract-plugin
export default {"range":"range_range__q5g5x"};